<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Lokation" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<string-view label="Navn" v-model="entity.name" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Adresse" v-model="entity.address" />
					<form-line-layout>
						<string-view label="Postnummer" v-model="entity.zip" />
						<string-view label="By" :weight="2" v-model="entity.city" />
					</form-line-layout>
					<string-view label="Land" v-model="entity.country" />
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Opret" @click="create" />
		</div>
		<div v-if="form && id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';

	export default {
		data() {
			return {
				entity: {
					name: null,
					address: null,
					zip: null,
					city: null,
					country: null
				},
				active: 'details'
			};
		},
		components: {
			'TextView': TextView,
			'StringView': StringView
		},
		computed: {
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				if (this.id) {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
						/*{
							name: 'contacts',
							label: 'Contacts'
						}*/
					];
				} else {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
					];
				}
			}
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			invoiceSelect(name, id, label) {
				
				
				

				this.input(name, id);
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			create() {
				var win = this;

				
				

				this.axios
					.post('/warehouse/locations/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});		
			},
			update() {
				
				

				var win = this;

				this.axios
					.put('/warehouse/locations/' + this.id + '/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		mounted: function() {
			
			

			var self = this;

			if (this.id) {
				this.axios
					.get('/warehouse/locations/' + this.id + '/')
					.then(function (r) {
						self.entity = r.data;
						self.entity.roles = {...self._roles, ...self.entity.roles};
					});
			}
		}
	}
</script>

<style lang="scss">
	
</style>
